import { Oval } from 'react-loading-icons';

export default function Loading() {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Oval speed={.5} stroke="#44c1cd" className="loading" />
    </div>
  );
}
